var map = {
	"./drag_s.webp": 8601,
	"./lambert_long_s.webp": 6371,
	"./lambert_s.webp": 7548,
	"./language/a1_s.webp": 8060,
	"./language/a2_s.webp": 8021,
	"./language/a3_s.webp": 162,
	"./language/b1_s.webp": 691,
	"./language/b2_s.webp": 286,
	"./language/b3_s.webp": 1697,
	"./language/c1_s.webp": 5546,
	"./language_s.webp": 8305,
	"./newonce/a1_s.webp": 2613,
	"./newonce/a2_s.webp": 9004,
	"./newonce/b1_s.webp": 9434,
	"./newonce/b2_s.webp": 575,
	"./newonce_s.webp": 8038,
	"./punk_s.webp": 6163,
	"./sso_s.webp": 6682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7109;